import { render } from "./Stats.vue?vue&type=template&id=73d01b6d"
const script = {}
script.render = render

export default script